<template>
  <div class="reports">
    <h1 style="margin: 0 0 4px">Reporting</h1>
    <div class="columns">
      <div class="column">
        <h3>Billing</h3>
        <ul>
          <li>Sales by Account</li>
          <li>Invoice Summary</li>
          <li>Invoice Detail</li>
          <li>Customer Balance Summary</li>
        </ul>
      </div>
      <div class="column">
        <h3>Scheduling</h3>
        <ul>
          <li>Reservation Detail</li>
          <li>Cancellation Detail</li>
          <li>Class/Meeting Detail</li>
          <li>Weekly Hours</li>
        </ul>
      </div>
    </div>
    <coming-soon-modal />
  </div>
</template>

<script>
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

export default {
  name: "Reports",
  components: { ComingSoonModal },
};
</script>

<style scoped>
.reports {
  text-align: left; /* Ensures overall alignment to the left */
}

.columns {
  display: flex;
  justify-content: space-between; /* Distributes space between columns */
  margin-top: 20px;
  gap: 20px; /* Gap between columns */
  width: 100%; /* Full width of the container */
}

.column {
  flex: 1; /* Each column takes equal space */
  background-color: #f0f0f0; /* Light grey background for columns */
}

.column h3 {
  background-color: #f0f0f0;
  padding: 10px 20px;
  margin: 0; /* Removes default margin */
  text-align: left; /* Left aligns the text */
}

.column ul {
  list-style: none;
  padding: 10px; /* Matching left padding with headers */
  margin: 0; /* No extra space around the list */
  background-color: white; /* White background for list */
}

.column li {
  background-color: white;
  padding: 10px; /* Same padding as headers for alignment */
  border-bottom: 1px solid #f0f0f0; /* Light grey border */
  cursor: pointer;
  text-align: left; /* Text alignment */
}

.column li::after {
  content: "\f054"; /* FontAwesome chevron-right code */
  font-family: "Font Awesome 5 Free", serif; /* Ensures the icon font is applied */
  font-weight: 900; /* Needed for solid icons */
  float: right;
  font-size: 18px; /* Larger size for better visibility */
  color: lightgray;
}
</style>
